import React from 'react';

const SMS = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="7.5" cy="12" r="1" fill="#000" />
      <circle cx="12.5" cy="12" r="1" fill="#000" />
      <circle cx="17.5" cy="12" fill="#000" r="1" />
      <path d="m3.394 16.138.665.218a.7.7 0 0 0-.028-.508l-.637.29zm-.503 4.88.697-.063-.697.062zm.594.593.062-.697-.062.697zm4.88-.503.29-.637a.7.7 0 0 0-.508-.028l.219.665zM21.8 12a9.3 9.3 0 0 1-9.3 9.3v1.4c5.91 0 10.7-4.79 10.7-10.7h-1.4zm-9.3-9.3a9.3 9.3 0 0 1 9.3 9.3h1.4c0-5.91-4.79-10.7-10.7-10.7v1.4zM3.2 12a9.3 9.3 0 0 1 9.3-9.3V1.3C6.59 1.3 1.8 6.09 1.8 12h1.4zm.83 3.848A9.264 9.264 0 0 1 3.2 12H1.8c0 1.578.342 3.078.957 4.428l1.274-.58zm-.442 5.107c-.078-.877-.137-2.744.47-4.599l-1.33-.436c-.693 2.115-.62 4.2-.534 5.16l1.394-.125zm-.04-.041a.05.05 0 0 1 .026.014.05.05 0 0 1 .014.027l-1.394.125c.059.657.572 1.17 1.228 1.228l.125-1.394zm4.6-.471c-1.855.608-3.724.55-4.6.47l-.126 1.395c.96.086 3.046.16 5.162-.535l-.437-1.33zm4.352.857a9.265 9.265 0 0 1-3.845-.83l-.58 1.275c1.35.614 2.849.955 4.425.955v-1.4z" fill="#000" />
    </svg>
  );
};

export default SMS;
